import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum WsConnectionState {
  CONNECTING   = 'CONNECTING',
  CONNECTED    = 'CONNECTED',
  RECONNECTING = 'RECONNECTING',
  CLOSED       = 'CLOSED',
  ERROR        = 'ERROR',
}

export interface WsConnectionEvent {
  state: WsConnectionState;
  reConnection: boolean;
}

@Injectable({ providedIn: 'root' })
export class WsConnectionService {
  readonly wsState$ = new BehaviorSubject<WsConnectionEvent>({
    state: WsConnectionState.CLOSED,
    reConnection: false,
  });

  onConnectionStatusChange(state: WsConnectionState, reConnection: boolean): void {
    this.wsState$.next({ state, reConnection });
  }
}
